import { createAsyncThunk } from "@reduxjs/toolkit";
import fsrHttpInstance, { fsrHttpConfiguration } from "../serviceFsrClients";
import { normalizeEntity } from "../entities/paymentCategoryEntity";
import { setFlashError } from "../slices/commons/flashSliceCommon";

export const fetchPaymentCategories = createAsyncThunk(
	"datasources/paymentCategories/fetchPaymentCategories",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/payment-categories/index", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.paymentCategories);
			
			return { 
				...normalized, 
				pagination: response.data.pagination || {} 
			};
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The payment category could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);